<form class="status-form" (ngSubmit)="submit()">
  <div class="status-form__field">
    <label class="sr-only" [for]="inputId">Write your status update here</label>
    <textarea
      class="status-form__input"
      rows="2"
      name="content"
      placeholder="Write your status update here"
      [id]="inputId"
      [maxlength]="maxChars"
      [attr.aria-describedby]="inputId + 'Count'"
      [(ngModel)]="content"></textarea>

    <div class="status-form__toolbar">
      @if (attachment(); as a) {
        <span class="status-form__chip">
          <span class="material-icons" aria-hidden="true">{{ a.icon }}</span>
          <span class="status-form__chip-label">{{ a.label }}</span>
          <button type="button" class="status-form__chip-remove" [attr.aria-label]="'Remove attachment ' + a.label" (click)="removeAttachment()">
            <span class="material-icons" aria-hidden="true">close</span>
          </button>
        </span>
      }
      <span class="status-form__attach">
        <button type="button" class="status-form__icon-btn" aria-label="Insert an image" data-picker="image" [attr.aria-expanded]="pickerMode() === 'image'" (click)="togglePicker('image')">
          <span class="material-icons" aria-hidden="true">image</span>
        </button>
        <button type="button" class="status-form__icon-btn" aria-label="Insert a video" data-picker="video" [attr.aria-expanded]="pickerMode() === 'video'" (click)="togglePicker('video')">
          <span class="material-icons" aria-hidden="true">play_circle_outline</span>
        </button>
      </span>
    </div>
  </div>

  @if (pickerMode(); as mode) {
    <ut-status-attachment-picker [mode]="mode" (attached)="setAttachment($event)" (closed)="closePicker()"></ut-status-attachment-picker>
  }

  <div class="status-form__footer">
    <!-- Read with the field; only announced live near the limit, not on every keystroke. -->
    <span class="status-form__count" [id]="inputId + 'Count'" [attr.aria-live]="remainingChars <= 20 ? 'polite' : null">{{ remainingChars }} characters remaining</span>
    <span class="status-form__buttons">
      @if (cancellable) {
        <button type="button" class="ut-btn ut-btn--secondary ut-btn--sm" (click)="cancelled.emit()">Cancel</button>
      }
      <button type="submit" class="ut-btn ut-btn--sm" [disabled]="busy">{{ submitLabel }}</button>
    </span>
  </div>
</form>
